import React, { useEffect, useState } from "react";
import Header from "components/Headers/Header";
import TableComponent from "components/TableComponent";
import { Card, Container, Row, Spinner, Button, Col } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getNewsletterEmails } from "store/actions/NewsletterEmailsAction";
import { CSVLink } from "react-csv";

const NewsletterEmails = () => {
  const [loading, setLoading] = useState(true);
  const [loadMoreLoading, setLoadMoreLoading] = useState(false);
  const dispatch = useDispatch();
  const { emails, lastDoc, hasMore } = useSelector((state) => state.newsletter);

  useEffect(() => {
    setLoading(true);
    dispatch(
      getNewsletterEmails("", () => {
        setLoading(false);
      })
    );
  }, []);

  const loadMore = () => {
    setLoadMoreLoading(true);
    dispatch(
      getNewsletterEmails(lastDoc, () => {
        setLoadMoreLoading(false);
      })
    );
  };

  const columns = ["Email", "Subscribed At"];
  const keyMap = {
    Email: "email",
    "Subscribed At": "subscribedAt",
  };

  const csvHeaders = [
    { label: "Email", key: "email" },
    { label: "Subscribed At", key: "subscribedAt" },
  ];

  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <Card className="p-2">
          {loading ? (
            <div className="text-center my-4">
              <Spinner size="lg" color="primary" />
            </div>
          ) : (
            <>
              <Row className="mb-3 px-3 pt-3">
                <Col className="d-flex justify-content-between align-items-center">
                  <h3 className="mb-0">Newsletter Emails</h3>
                  <CSVLink
                    filename={`newsletter-emails-${new Date().toISOString().split('T')[0]}.csv`}
                    headers={csvHeaders}
                    data={emails}
                    className="btn btn-primary"
                  >
                    <i className="fa fa-download mr-2"></i>
                    Export to CSV
                  </CSVLink>
                </Col>
              </Row>
              <TableComponent columns={columns} data={emails} keyMap={keyMap} />
              {hasMore && (
                <div className="text-center py-4">
                  <Button
                    onClick={loadMore}
                    color="primary"
                    disabled={loadMoreLoading}
                  >
                    {loadMoreLoading ? <Spinner size="sm" /> : "Load More"}
                  </Button>
                </div>
              )}
            </>
          )}
        </Card>
      </Container>
    </>
  );
};

export default NewsletterEmails;
